import { useState, useEffect } from 'react'

export function useUserCity(fallback = 'Local') {
  const [city, setCity] = useState<string>(fallback)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const tryApis = async () => {
      try {
        const res = await fetch('https://ipwho.is/')
        const data = await res.json()
        if (data?.success && data?.city) {
          setCity(data.city)
          setLoading(false)
          return
        }
        if (data?.success && data?.country) {
          setCity(data.country)
          setLoading(false)
          return
        }
      } catch (_) {}

      try {
        const res = await fetch('https://freeipapi.com/api/json')
        const data = await res.json()
        if (data?.cityName && data.cityName !== '-') {
          setCity(data.cityName)
          setLoading(false)
          return
        }
        if (data?.countryName) {
          setCity(data.countryName)
          setLoading(false)
          return
        }
      } catch (_) {}

      try {
        const res = await fetch('https://ipapi.co/json/')
        const data = await res.json()
        if (data?.city && !data?.error) {
          setCity(data.city)
          setLoading(false)
          return
        }
        if (data?.country_name && !data?.error) {
          setCity(data.country_name)
          setLoading(false)
          return
        }
      } catch (_) {}

      // All APIs failed — show fallback
      setLoading(false)
    }

    tryApis()
  }, [])

  return { city, loading }
}
